module.exports = __webpack_public_path__ + "assets/img/slogan-929a55b2.png";